import React from 'react';
import ReactDOM from 'react-dom/client';
import { EngineReportPrint } from '@/components/print/EngineCommercialPrints';
import type { PrintColumn } from '@/print-engine';
import type { SimplePrintLine } from '@/print-engine/adapters/simple-document';

export type OpenEngineReportPrintInput = {
  title: string;
  documentNumber: string;
  partyName?: string;
  metaLines?: Array<{ label: string; value: string }>;
  columns: PrintColumn[];
  lines: SimplePrintLine[];
  finalNote?: string;
  docType?: string;
  /** Wide registers — Wave E report profile on A4 landscape. */
  landscape?: boolean;
};

/**
 * Mount a report-profile EngineReportPrint overlay (composed A4 pages + page numbers).
 * Used by finance / ORC-style report screens.
 */
export function openEngineReportPrint(input: OpenEngineReportPrintInput): void {
  const mainContent = document.querySelector('.ant-layout-content') as HTMLElement | null;
  const printContainer = document.createElement('div');
  printContainer.id = 'print-container';
  document.body.appendChild(printContainer);
  if (mainContent) mainContent.style.display = 'none';

  let root: ReactDOM.Root | null = null;
  const cleanup = () => {
    root?.unmount();
    if (printContainer.parentNode) document.body.removeChild(printContainer);
    if (mainContent) mainContent.style.display = '';
    window.removeEventListener('afterprint', cleanup);
  };

  root = ReactDOM.createRoot(printContainer);
  root.render(
    <EngineReportPrint
      docType={input.docType}
      title={input.title}
      documentNumber={input.documentNumber}
      partyName={input.partyName}
      metaLines={input.metaLines}
      columns={input.columns}
      lines={input.lines}
      finalNote={input.finalNote}
      landscape={input.landscape}
      onClose={cleanup}
    />
  );
  window.addEventListener('afterprint', cleanup);
}
